import { FunctionComponent, useState } from 'react';
import { Badge, BadgeProps } from '@shopify/polaris';

export interface FeatureBadgeProps extends Pick<BadgeProps, 'size'> {
  betaStatusStart?: Date;
  betaStatusEnd?: Date;
  newStatusStart?: Date;
  newStatusEnd?: Date;
}

enum FeatureBadgeStatus {
  BETA = 'BETA',
  NEW = 'NEW',
}

const getFeatureBadgeStatus = (
  params: FeatureBadgeProps,
): FeatureBadgeStatus | undefined => {
  const { betaStatusEnd, betaStatusStart, newStatusEnd, newStatusStart } =
    params;

  let featureBadgeStatus: FeatureBadgeStatus | undefined;

  const currentDate = new Date().getTime();
  const afterBetaStatusStart =
    betaStatusStart && betaStatusStart.getTime() < currentDate;
  const beforeBetaStatusEnd = betaStatusEnd
    ? currentDate < betaStatusEnd.getTime()
    : true;
  const afterNewStatusStart =
    newStatusStart && newStatusStart.getTime() < currentDate;
  const beforeNewStatusEnd = newStatusEnd
    ? currentDate < newStatusEnd.getTime()
    : true;

  if (afterNewStatusStart && beforeNewStatusEnd) {
    featureBadgeStatus = FeatureBadgeStatus.NEW;
  }

  if (afterBetaStatusStart && beforeBetaStatusEnd) {
    featureBadgeStatus = FeatureBadgeStatus.BETA;
  }

  return featureBadgeStatus;
};

const FeatureBadge: FunctionComponent<FeatureBadgeProps> = (props) => {
  const { size } = props;
  const [featureBadgeStatus] = useState<FeatureBadgeStatus | undefined>(
    getFeatureBadgeStatus(props),
  );

  if (!featureBadgeStatus) return null;

  const badgeStatusIsNew = featureBadgeStatus === FeatureBadgeStatus.NEW;

  return <Badge size={size}>{badgeStatusIsNew ? 'New' : 'Beta'}</Badge>;
};

export default FeatureBadge;
